var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"form-group row bank_details\" ng-repeat=\"detail in field.values\"> <div class=\"col-md-4 col-lg-4\"> <label> <span translate=\"{{ '.' + detail.name }}\" translate-default=\"{{ detail.name }}\"></span>: </label> </div> <div class=\"col-md-8 col-lg-8\"> <p class=\"form-control\" name=\"{{detail.name}}\" ng-readonly=\"true\"> {{detail.value}} </p> </div> </div>";
ngModule.run(["$templateCache",function(c){c.put("bankDetails/templates/index.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/bankDetails/templates/index.html
 ** module id = 24
 ** module chunks = 1
 **/